module.exports = __webpack_public_path__ + "static/img/chinazh.745c0fdf.png";